export const KEYWORD_TYPE_OPTIONS = [
    { label: 'Generic', value: 1 },
    { label: 'Branded', value: 2 }
]